/**
 * 版本升级 热更新检查
 */
import axios from '../../common/axiosSetting'
class updateApp {
	constructor(){
		let _this = this;
		plus.runtime.getProperty(plus.runtime.appid,function(inf){
			_this.checkVersions(inf.version);
		});
	}
	checkVersions(version) {
		axios.AxiosIns({
			url : 'app/padinfo',
			domain : 'www',
			params : {
				version : version,
				os_name : plus.os.name,
				os_version : plus.os.version,
				os_model : plus.device.model
			}
		}).then((res)=>{
			if (Object.keys(res.data.app).length > 0) {
				var app_info = res.data.app;
				var pkgType = (app_info.url).slice(-3)
				//强制更新
				if (app_info.is_constraint === 1) {
					if (pkgType !== 'wgt') {
						plus.nativeUI.showWaiting("请安装最新版本后重启应用...");
						plus.runtime.openURL(app_info.url);
					} else {
						let dtask = plus.downloader.createDownload(app_info.url, {}, function (d, status) {
							if (status === 200) {
								plus.nativeUI.closeWaiting();
								plus.nativeUI.showWaiting("正在更新...");
								var path = d.filename;
								plus.runtime.install(path, {}, function () {
									plus.nativeUI.closeWaiting();
									plus.nativeUI.toast("更新完成");
									plus.runtime.restart();
								}, function (e) {
									plus.nativeUI.alert("更新失败，请重试！\n" + JSON.stringify(e));
								});
							} else {
								plus.nativeUI.showWaiting("更新失败，请退出重试！");
							}
						});
						dtask.start();
					}
				} else {
					//立即更新
					if (pkgType !== 'wgt') {
						plus.runtime.openURL(app_info.url);
					} else {
						plus.nativeUI.showWaiting("正在后台更新...");
						let dtask = plus.downloader.createDownload(app_info.url, {}, function (d, status) {
							if (status === 200) {
								var path = d.filename;
								plus.runtime.install(path, {}, function () {
									plus.nativeUI.closeWaiting();
									plus.nativeUI.toast("更新完成");
									plus.runtime.restart();
								}, function (e) {
									plus.nativeUI.closeWaiting();
									plus.nativeUI.alert("更新失败，请重试！\n" + JSON.stringify(e));
								});
							} else {
								plus.nativeUI.alert("网络错误，更新失败！");
							}
						});
						dtask.start();
					}
				}
			}
		});
	}
}
document.addEventListener('plusready', () => {
	new updateApp();
});



// WEBPACK FOOTER //
// ./src/assets/js/checkAppUpdate.js